const yellow = {
  light: '#FFF3DB',
  main: '#FFC24D',
  dark: '#CD6227'
};
export default yellow;